import {
  VALIDATE_ADDRESS_ENDPOINT,
  RELATE_LOCATIONS_TO_CART_ADDRESS_ENDPOINT,
  DELIVERABLE_LOCATIONS_ENDPOINT
} from 'base/constants/endpoints';
import { apiAction } from 'base/utils/apiHelpers';
import {
  VALIDATE_ADDRESS_REQUEST,
  VALIDATE_ADDRESS_SUCCESS,
  VALIDATE_ADDRESS_FAILURE,
  RELATE_LOCATIONS_TO_CART_REQUEST,
  RELATE_LOCATIONS_TO_CART_SUCCESS,
  RELATE_LOCATIONS_TO_CART_FAILURE,
  GET_DELIVERABLE_LOCATIONS_REQUEST,
  GET_DELIVERABLE_LOCATIONS_SUCCESS,
  GET_DELIVERABLE_LOCATIONS_FAILURE
} from 'locations/constants/actionTypes';

export const validateAddressInDeliveryZone = parsedAddress => dispatch => {
  const payload = parsedAddress;
  const endpoint = VALIDATE_ADDRESS_ENDPOINT;
  return dispatch(
    apiAction(
      endpoint,
      'POST',
      [
        VALIDATE_ADDRESS_REQUEST,
        VALIDATE_ADDRESS_SUCCESS,
        VALIDATE_ADDRESS_FAILURE
      ],
      payload
    )
  );
};

export const setCartAddressAndGetLocationsInRelation = parsedAddress => dispatch => {
  const payload = parsedAddress;
  const endpoint = RELATE_LOCATIONS_TO_CART_ADDRESS_ENDPOINT;
  return dispatch(
    apiAction(
      endpoint,
      'POST',
      [
        RELATE_LOCATIONS_TO_CART_REQUEST,
        RELATE_LOCATIONS_TO_CART_SUCCESS,
        RELATE_LOCATIONS_TO_CART_FAILURE
      ],
      payload
    )
  );
};

/**
 * only used on location list page if cart already has locations
 */
export const getDeliverableLocations = () => dispatch => {
  const endpoint = DELIVERABLE_LOCATIONS_ENDPOINT;
  return dispatch(
    apiAction(endpoint, 'POST', [
      GET_DELIVERABLE_LOCATIONS_REQUEST,
      GET_DELIVERABLE_LOCATIONS_SUCCESS,
      GET_DELIVERABLE_LOCATIONS_FAILURE
    ])
  );
};
